// Duration formatting helpers. Elapsed is always derived from server timestamps
// upstream; these only format for display.

export function fmtClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}

export function fmtDuration(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  if (h > 0) return m > 0 ? `${h}h ${m}m` : `${h}h`;
  if (m > 0) return `${m}m`;
  return s > 0 ? `${s}s` : "0m";
}

export function fmtMinutes(totalMinutes) {
  return fmtDuration((totalMinutes || 0) * 60);
}

export function minutesToHM(mins) {
  const m = Math.max(0, Math.round(mins || 0));
  return { h: Math.floor(m / 60), m: m % 60 };
}
